var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      attrs: {
        data: _vm.eventLogs,
        "cell-class-name": "el-table-cell",
        "row-class-name": "event-table-row",
        "header-row-class-name": "el-table-header",
      },
    },
    [
      _c(
        "div",
        { staticClass: "empty", attrs: { slot: "empty" }, slot: "empty" },
        [
          _c("img", { attrs: { src: _vm.images.empty } }),
          _c("p", [_vm._v(_vm._s(_vm.$t("Dashboard.none_data")))]),
        ]
      ),
      _c("el-table-column", {
        attrs: {
          prop: "name",
          label: _vm.$t("Dashboard.table-cell04"),
          width: "130",
        },
      }),
      _c("el-table-column", {
        attrs: { label: _vm.$t("Dashboard.table-cell05") },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c("el-tag", { attrs: { size: "mini" } }, [
                  _vm._v(_vm._s(_vm.showActions(props.row.action_type))),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("Dashboard.table-cell02"),
          width: "137",
          align: "center",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(props.row.oneday_access.toLocaleString())),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "percent",
                    class: _vm.checkUpdown(
                      props.row.beforeday_access,
                      props.row.oneday_access
                    ),
                  },
                  [
                    _c("i", {
                      class: _vm.checkUpdownIcon(
                        props.row.beforeday_access,
                        props.row.oneday_access
                      ),
                    }),
                    _vm._v(
                      _vm._s(
                        _vm.checkPercentage(
                          props.row.beforeday_access,
                          props.row.oneday_access
                        )
                      )
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("Dashboard.table-cell06"),
          width: "80",
          align: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (props) {
              return [
                _c("span", [_vm._v(_vm._s(props.row.total.toLocaleString()))]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }